import { api } from '../index';

const prefix = '/api/pickup/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiPickupStart(param) {
	return api.post(prefix + 'pickupStart', param);
}

export function apiPickupComplete(param) {
	return api.post(prefix + 'pickupComplete', param);
}

export function apiPickupStartBatch(param) {
	return api.post(prefix + 'pickupStartBatch', param);
}

export function apiPickupCompleteBatch(param) {
	return api.post(prefix + 'pickupCompleteBatch', param);
}

export function apiPickupDesignated(param) {
	return api.post(prefix + 'pickupDesignated', param);
}

export function apiChangePicker(param) {
	return api.post(prefix + 'changePicker', param);
}

export function apiDeletePickupInfo(param) {
	return api.post(prefix + 'deletePickupInfo', param);
}

export function apiCheckPickingOrder(barcode) {
	return api.get(prefix + 'checkPickingOrder', { params: { barcode } });
}
